import { apiJson, apiUrl } from "../utils/api";

function buildUserParams(userId) {
  const params = new URLSearchParams();
  if (userId) params.set("user_id", String(userId));
  return params;
}

export async function fetchEbookCategories() {
  const { data } = await apiJson("/api/ebooks/categories");
  return data.items || [];
}

export async function fetchEbooks({
  page = 1,
  pageSize = 20,
  categoryId = "",
  keyword = "",
  featured = false,
  sort = "hot",
  userId = "",
} = {}) {
  const params = buildUserParams(userId);
  params.set("page", String(page));
  params.set("page_size", String(pageSize));
  if (categoryId) params.set("category_id", String(categoryId));
  if (keyword) params.set("keyword", keyword.trim());
  if (featured) params.set("featured", "1");
  if (sort) params.set("sort", sort);
  const { data } = await apiJson(`/api/ebooks?${params.toString()}`);
  return data;
}

export async function fetchEbookDetail(ebookId, userId = "") {
  const params = buildUserParams(userId);
  const suffix = params.toString() ? `?${params.toString()}` : "";
  const { res, data } = await apiJson(`/api/ebooks/${ebookId}${suffix}`);
  if (!res.ok) {
    throw new Error(data?.detail || "电子书不存在");
  }
  return data;
}

export async function fetchMyEbookDownloads(userId, page = 1, pageSize = 20) {
  const params = buildUserParams(userId);
  params.set("page", String(page));
  params.set("page_size", String(pageSize));
  const { res, data } = await apiJson(`/api/ebooks/my-downloads?${params.toString()}`);
  if (!res.ok) {
    throw new Error(data?.detail || "加载下载记录失败");
  }
  return data;
}

export function formatFileSize(bytes) {
  const size = Number(bytes) || 0;
  if (size <= 0) return "";
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export async function downloadEbookFile(ebookId, userId, fallbackName = "ebook") {
  const url = apiUrl(`/api/ebooks/${ebookId}/download?user_id=${encodeURIComponent(userId)}`);
  const res = await fetch(url);
  const contentType = (res.headers.get("content-type") || "").toLowerCase();

  if (!res.ok) {
    if (contentType.includes("application/json")) {
      const data = await res.json();
      throw new Error(data.detail || "下载失败");
    }
    throw new Error(`下载失败 (${res.status})`);
  }

  const blob = await res.blob();
  let filename = fallbackName;
  const disposition = res.headers.get("content-disposition") || "";
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
  if (match?.[1]) {
    try {
      filename = decodeURIComponent(match[1].replace(/"/g, ""));
    } catch {
      filename = match[1].replace(/"/g, "");
    }
  }

  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
